<template>
  <v-card
    class="mx-auto"
    hover
  >
    <v-card-title>
      <v-icon :color="userColor" left>mdi-school</v-icon>
      {{ instance.name }}
    </v-card-title>
    <v-card-subtitle>{{ instance.url }}</v-card-subtitle>
    <v-card-text>{{ instance.description }}</v-card-text>
    <v-card-actions>
      <v-container>
        <v-row no-gutters v-if="instance.isRegistered">
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    dark
                    depressed
                    tile
                    large
                    @click="unregisterInstance(instance.id)"
                    v-on="on"
                    v-bind="attrs"
                >
                  <v-icon left>mdi-link-off</v-icon>
                  {{ $t("settings.externalMoodles.card.unregister") }}
                </v-btn>
              </template>
              <span>{{ $t("settings.externalMoodles.card.unregisterHelp") }}</span>
            </v-tooltip>
          </v-col>
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    depressed
                    tile
                    large
                    v-on="on"
                    v-bind="attrs"
                    class="no__click"
                >
                  <v-icon left>mdi-calendar</v-icon>
                  {{ instance.validUntil.toLocaleDateString() }}
                </v-btn>
              </template>
              <span>{{ $t("settings.externalMoodles.card.until") }}</span>
            </v-tooltip>
          </v-col>
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    depressed
                    tile
                    large
                    v-on="on"
                    v-bind="attrs"
                    class="no__click"
                >
                  <v-icon left>mdi-account</v-icon>
                  {{ instance.username }}
                </v-btn>
              </template>
              <span>{{ $t("settings.externalMoodles.card.username") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    dark
                    depressed
                    tile
                    large
                    @click="registerInstance(instance.id)"
                    v-on="on"
                    v-bind="attrs"
                >
                  <v-icon left>mdi-link-plus</v-icon>
                  {{ $t("settings.externalMoodles.card.register") }}
                </v-btn>
              </template>
              <span>{{ $t("settings.externalMoodles.card.registerHelp") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: "MoodleRegistration",
    props: {
      instance: {type: Object, required: true}
    },
    computed: {
      ...mapGetters(['userColor'])
    },
    methods: {
      ...mapActions(['unregisterInstance', 'registerInstance']),
    }
  }
</script>

<style lang="scss" scoped>
@import 'src/scss/constants.scss';

  .v-card {
    &:hover{
      cursor: default;
    }
    margin-bottom: 1em;
  }
  .v-card__actions {
    .no__click:hover {
      cursor: default;
    }
    span > span {
      margin-left: 1em;
    }
    @media all and (max-width: $mediaXSmall){
      .row{
        justify-content: space-around;
        .col{
          flex-grow: 0;
        }
      }
      .v-btn{
        margin-bottom: 5px;
      }
    }
  }
</style>
